/* @jsx h */
import { h } from "vue";

interface DateGroupHeaderProps {
  date: string;
  count: number;
}

export const DateGroupHeader = (props: DateGroupHeaderProps) => {
  return (
    <div class="flex items-center gap-3 py-2 px-1">
      <div class="flex items-center gap-2">
        <span class="material-symbols-outlined text-sm text-primary/60">calendar_today</span>
        <span class="text-sm font-semibold text-base-content/80">{props.date}</span>
        <span class="text-xs text-base-content/40">({props.count})</span>
      </div>
      <div class="flex-1 h-px bg-base-300/50"></div>
    </div>
  );
};
